import { vars } from "@common/styles";
import styled from "styled-components";

export const OpenExternalButton = styled.button`
  border: 1px solid ${vars.colors.grey80};
  background: ${vars.colors.grey100};
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 0.5rem;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    svg {
      path {
        stroke: ${vars.colors.white};
      }
    }
  }
`;
